import React from 'react';
import { Helmet } from 'react-helmet-async';
import { alerts } from '../data/mockData';
import { FiAlertTriangle, FiExternalLink, FiMapPin, FiCalendar } from 'react-icons/fi';

const Alerts = () => {
  return (
    <>
      <Helmet>
        <title>Safety Alerts & Recalls | Recall Moringa</title>
        <meta name="description" content="Latest moringa supplement recalls, FDA warnings, and CDC outbreak alerts." />
      </Helmet>

      <div className="bg-gray-50 min-h-screen py-12">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="mb-8">
              <h1 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4">Safety Alerts & Recalls</h1>
              <p className="text-gray-600 text-lg">
                Official notifications from FDA, CDC, and state health departments regarding moringa products.
              </p>
            </div>

            <div className="space-y-6">
              {alerts.map((alert) => (
                <div key={alert.id} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden hover:shadow-md transition-shadow">
                  <div className={`h-2 w-full ${
                    alert.type === 'URGENT RECALL' ? 'bg-alert' : 
                    alert.type === 'OUTBREAK ALERT' ? 'bg-orange-500' : 'bg-yellow-500'
                  }`} />
                  
                  <div className="p-6 md:p-8">
                    <div className="flex flex-col md:flex-row md:items-start justify-between gap-4 mb-4">
                      <div>
                        <span className={`inline-block px-3 py-1 rounded-full text-xs font-bold tracking-wide uppercase mb-3 ${
                          alert.type === 'URGENT RECALL' ? 'bg-red-100 text-red-800' : 
                          alert.type === 'OUTBREAK ALERT' ? 'bg-orange-100 text-orange-800' : 'bg-yellow-100 text-yellow-800'
                        }`}>
                          {alert.type}
                        </span>
                        <h2 className="text-xl md:text-2xl font-bold text-gray-900 leading-tight">
                          {alert.title}
                        </h2>
                      </div>
                      <div className="flex-shrink-0 text-right">
                         <span className="block text-sm font-bold text-gray-500 mb-1">Risk Level</span>
                         <span className={`inline-block px-3 py-1 rounded text-sm font-bold text-white ${
                           alert.riskLevel === 'High' ? 'bg-alert' : 'bg-yellow-500'
                         }`}>
                           {alert.riskLevel}
                         </span>
                      </div>
                    </div>

                    <div className="flex flex-wrap gap-4 text-sm text-gray-500 mb-6 border-b border-gray-100 pb-6">
                      <span className="flex items-center gap-1"><FiCalendar /> {alert.date}</span>
                      <span className="flex items-center gap-1 font-semibold text-primary"><FiMapPin /> Source: {alert.source}</span>
                    </div>

                    <div className="prose prose-blue max-w-none text-gray-700 mb-6">
                      <p>{alert.summary}</p>
                      {alert.affectedProducts && (
                        <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-4">
                          <h4 className="font-bold text-gray-900 text-sm uppercase mb-2">Affected Products:</h4>
                          <ul className="list-disc list-inside space-y-1">
                            {alert.affectedProducts.map((p, idx) => (
                              <li key={idx} className="text-sm">{p}</li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>

                    <div className="flex justify-end">
                      <a 
                        href={alert.link} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 bg-white border border-gray-300 hover:border-primary hover:text-primary text-gray-700 font-medium py-2 px-4 rounded transition-colors"
                      >
                        Source Document <FiExternalLink />
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Alerts;